import { DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_dirembox extends Layout {
    sourceDidbalias: DataSource;
    sourceDirembox2: DataSource;
    sourceDirembox: DataSource;
    sourceImgApps: DataSource;
    swStatus: Switch;
    tbRmbxId: Textbox;
    textboxDidbDbalias: Textbox;
    textboxDidbDesc: Textbox;
    textboxImapAppid: Textbox;
    textboxImapAppname: Textbox;
    textboxRmbxAppid: Textbox;
    textboxRmbxBkuphost: Textbox;
    textboxRmbxBkuppath: Textbox;
    textboxRmbxDba: Textbox;
    textboxRmbxDesc: Textbox;
    textboxRmbxExe: Textbox;
    textboxRmbxHost: Textbox;
    textboxRmbxId: Textbox;
    textboxRmbxPath: Textbox;
    textboxRmbxType: Textbox;
}
